module.exports = __webpack_public_path__ + "assets/img/thumb-AstonRX-Landing-Page.46b0e008.jpg";